/* eslint-disable */
const structure = {
  1: {
    like: null,
    dislike: null,
    values: ['ph1', 'tn1', 'ks1', 'se1', 'ku1', 'vo1'],
  },
  2: {
    like: null,
    dislike: null,
    values: ['vo2', 'ph2', 'tn2', 'ks2', 'se2', 'ku2'],
  },
  3: {
    like: null,
    dislike: null,
    values: ['ku3', 'vo3', 'ph3', 'tn3', 'ks3', 'se3'],
  },
  4: {
    like: null,
    dislike: null,
    values: ['se4', 'ku4', 'vo4', 'ph4', 'tn4', 'ks4'],
  },
  5: {
    like: null,
    dislike: null,
    values: ['ks5', 'se5', 'ku5', 'vo5', 'ph5', 'tn5'],
  },
  6: {
    like: null,
    dislike: null,
    values: ['tn6', 'ks6', 'se6', 'ku6', 'vo6', 'ph6'],
  },
  7: {
    like: null,
    dislike: null,
    values: ['ph7', 'tn7', 'ks7', 'se7', 'ku7', 'vo7'],
  },
  8: {
    like: null,
    dislike: null,
    values: ['vo8', 'ph8', 'tn8', 'ks8', 'se8', 'ku8'],
  },
  9: {
    like: null,
    dislike: null,
    values: ['ku9', 'vo9', 'ph9', 'tn9', 'ks9', 'se9'],
  },
  10: {
    like: null,
    dislike: null,
    values: ['se10', 'ku10', 'vo10', 'ph10', 'tn10', 'ks10'],
  },
  11: {
    like: null,
    dislike: null,
    values: ['ks3', 'se4', 'ku5', 'vo6', 'ph1', 'tn2'],
  },
  12: {
    like: null,
    dislike: null,
    values: ['tn3', 'ks4', 'se5', 'ku6', 'vo7', 'ph2'],
  },
  13: {
    like: null,
    dislike: null,
    values: ['ph3', 'tn4', 'ks5', 'se6', 'ku7', 'vo8'],
  },
  14: {
    like: null,
    dislike: null,
    values: ['vo9', 'ph4', 'tn5', 'ks6', 'se7', 'ku8'],
  },
  15: {
    like: null,
    dislike: null,
    values: ['ku9', 'vo10', 'ph5', 'tn6', 'ks7', 'se8'],
  },
  16: {
    like: null,
    dislike: null,
    values: ['se9', 'ku10', 'vo1', 'ph6', 'tn7', 'ks8'],
  },
  17: {
    like: null,
    dislike: null,
    values: ['ks9', 'se10', 'ku1', 'vo2', 'ph7', 'tn8'],
  },
  18: {
    like: null,
    dislike: null,
    values: ['tn9', 'ks10', 'se1', 'ku2', 'vo3', 'ph8'],
  },
  19: {
    like: null,
    dislike: null,
    values: ['ph9', 'tn10', 'ks1', 'se2', 'ku3', 'vo4'],
  },
  20: {
    like: null,
    dislike: null,
    values: ['vo5', 'ph10', 'tn1', 'ks2', 'se3', 'ku4'],
  },
  21: {
    like: null,
    dislike: null,
    values: ['ku9', 'vo2', 'ph1', 'tn3', 'ks5', 'se7'],
  },
  22: {
    like: null,
    dislike: null,
    values: ['se8', 'ku10', 'vo3', 'ph2', 'tn4', 'ks6'],
  },
  23: {
    like: null,
    dislike: null,
    values: ['ks7', 'se9', 'ku1', 'vo4', 'ph3', 'tn5'],
  },
  24: {
    like: null,
    dislike: null,
    values: ['tn6', 'ks8', 'se10', 'ku2', 'vo5', 'ph4'],
  },
  25: {
    like: null,
    dislike: null,
    values: ['ph5', 'tn7', 'ks9', 'se1', 'ku3', 'vo6'],
  },
  26: {
    like: null,
    dislike: null,
    values: ['vo7', 'ph6', 'tn8', 'ks10', 'se2', 'ku4'],
  },
  27: {
    like: null,
    dislike: null,
    values: ['ku5', 'vo8', 'ph7', 'tn9', 'ks1', 'se3'],
  },
  28: {
    like: null,
    dislike: null,
    values: ['se4', 'ku6', 'vo9', 'ph8', 'tn10', 'ks2'],
  },
  29: {
    like: null,
    dislike: null,
    values: ['ks3', 'se5', 'ku7', 'vo10', 'ph9', 'tn1'],
  },
  30: {
    like: null,
    dislike: null,
    values: ['tn2', 'ks4', 'se6', 'ku8', 'vo1', 'ph10'],
  },
  31: {
    like: null,
    dislike: null,
    values: ['ph1', 'tn4', 'ks2', 'se10', 'ku3', 'vo7'],
  },
  32: {
    like: null,
    dislike: null,
    values: ['vo8', 'ph2', 'tn5', 'ks3', 'se1', 'ku4'],
  },
  33: {
    like: null,
    dislike: null,
    values: ['ku5', 'vo9', 'ph3', 'tn6', 'ks4', 'se2'],
  },
  34: {
    like: null,
    dislike: null,
    values: ['se3', 'ku6', 'vo10', 'ph4', 'tn7', 'ks5'],
  },
  35: {
    like: null,
    dislike: null,
    values: ['ks6', 'se4', 'ku7', 'vo1', 'ph5', 'tn8'],
  },
  36: {
    like: null,
    dislike: null,
    values: ['tn9', 'ks7', 'se5', 'ku8', 'vo2', 'ph6'],
  },
  37: {
    like: null,
    dislike: null,
    values: ['ph7', 'tn10', 'ks8', 'se6', 'ku9', 'vo3'],
  },
  38: {
    like: null,
    dislike: null,
    values: ['vo4', 'ph8', 'tn1', 'ks9', 'se7', 'ku10'],
  },
  39: {
    like: null,
    dislike: null,
    values: ['ku1', 'vo5', 'ph9', 'tn2', 'ks10', 'se8'],
  },
  40: {
    like: null,
    dislike: null,
    values: ['se9', 'ku2', 'vo6', 'ph10', 'tn3', 'ks1'],
  },
}

export default structure



// WEBPACK FOOTER //
// ./src/store/structure.js